import React from 'react';
import './TitleAndDate.css';


const TitleAndDate = ({ text, dates }) => {
  return (
    <div className="title-and-date">
      <h3 className="title-and-date-text">{text}</h3>
      <span className="title-and-date-dates">{dates}</span>
    </div>
  );
};

export default TitleAndDate;
